module.exports = __webpack_public_path__ + "img/slide14.d9e96aa5.png";